import { FiRepeat } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { usePortalSessionStore } from "@/features/portal/store/portal-session-store";
import { portalSignInHref } from "@/features/portal/portal-base";

/**
 * `/portal/switch-client` — switching to another linked client.
 *
 * Adaptation: the backend `select-client` handshake needs a fresh *pending*
 * (2FA-verified) token, which a bound session no longer holds. So rather than
 * re-listing clients here, we clear the session and send the client back
 * through the branded portal sign-in, where selecting a different client is
 * part of the normal auth flow.
 */
export function PortalSwitchClient() {
  const navigate = useNavigate();
  const portalName = usePortalSessionStore((s) => s.portalName);
  const brandingName = usePortalSessionStore((s) => s.branding?.portalName);
  const clearSession = usePortalSessionStore((s) => s.clearSession);

  function handleSwitch() {
    const handle = portalName ?? brandingName;
    clearSession();
    navigate(portalSignInHref(handle));
  }

  return (
    <div className="mx-auto w-full max-w-md">
      <Card>
        <CardHeader className="items-center text-center">
          <span className="bg-muted text-muted-foreground mb-2 flex size-12 items-center justify-center rounded-full">
            <FiRepeat className="size-6" aria-hidden />
          </span>
          <CardTitle className="text-xl">Switch client</CardTitle>
        </CardHeader>
        <CardContent className="grid gap-6 text-center">
          <p className="text-muted-foreground text-sm">
            To switch to another client, please sign in again. For your
            security we&apos;ll re-verify your identity before giving you access
            to a different client&apos;s information.
          </p>
          <Button className="h-11" onClick={handleSwitch}>
            Sign in again
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
